import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { PatientService } from '../patient.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from 'moment';
import { Patient } from '../patient';


@Component({
    selector: 'share-assessment-dialog',
    templateUrl: 'share-assessment-dialog.component.html',
    styleUrls: ['share-assessment-dialog.component.scss'],
})
export class ShareAssessmentDialogComponent implements OnInit {

    patientForm: FormGroup;
    platform = 'web';
    email = '';
    doa: any;
    @Input()
    min: 'D' | null;
    today = new Date();
    hrs = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    minutes = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
    hour: string;
    minute: string;
    preHrs: Array<any> = [];
    dateIso: any;
    dateTime: any;

    date: any;
    disabled = false;
    showSpinners = true;
    showSeconds = false;
    touchUi = false;
    enableMeridian = true;
    // minDate: any;
    minDate = new Date();
    maxDate: any;
    stepHour = 1;
    stepMinute = 5;
    // defaultTime: any;
    defaultTime: any;

    constructor(
        public dialogRef: MatDialogRef<ShareAssessmentDialogComponent>,
        private _formBuilder: FormBuilder,
        public patientService: PatientService,
        public snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: Patient,
    ) {
    }

    onNoClick(): void {
        this.dialogRef.beforeClosed();
    }

    /**
     * On init
     */
    ngOnInit(): void {

        console.log(this.dialogRef.componentInstance.data.doa);
        this.defaultTime =  new Date(this.dialogRef.componentInstance.data.doa);
        this.dateIso = new Date().toISOString().slice(0, 16);
        this.dateTime = new Date().toISOString().slice(0, 16);
        // this.minDate = new Date().toISOString().slice(0, 16);
        this.email = this.dialogRef.componentInstance.data.emailId;
        this.patientForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)], ''],
            // doa: ['', [Validators.required],],
            // hour: ['', [Validators.required],],
            // minute: ['', [Validators.required],],
            minDate: ['', []],
            dateTime: [{value:this.defaultTime}, [Validators.required]],
        });

        this.preHrs = this.hrs; // to keep previous value every selection

    }



    clickDobDatepicker(event: any) {
        const getDay = new Date();
        if (moment(event.value).toDate().getDate() === getDay.getDate()) {
            const filteredHrs = this.hrs.filter(value => {
                if (value > getDay.getHours()) {
                    return value;
                }
            })
            this.hrs = filteredHrs;
        } else {
            this.hrs = this.preHrs;
        }
        sessionStorage.setItem('doa', moment(event.value).toDate().getTime().toString());
    }

    changeEmail() {
        this.patientForm.reset();
    }

    addPatientDetail() {
        // sending data to patient module

        this.dialogRef.close(this.patientForm.value);
    }

    openSnackBar(message: string, action: string): void {
        this.snackBar.open(message, action, {
            duration: 4000,
        });
    }


    toggleMinDate(evt: any) {
        if (evt.checked) {
            this._setMinDate();
        } else {
            this.minDate = null;
        }
    }

    toggleMaxDate(evt: any) {
        if (evt.checked) {
            this._setMaxDate();
        } else {
            this.maxDate = null;
        }
    }

    private _setMinDate() {
        const now = new Date();
        this.minDate = new Date();
        this.minDate.setDate(now.getDate() - 1);
    }


    private _setMaxDate() {
        const now = new Date();
        this.maxDate = new Date();
        this.maxDate.setDate(now.getDate() + 1);
    }



    private handleError(error: Error): void {
        this.openSnackBar(error.message, 'OK');
        // this.notify.update(error.message, 'error');
    }
}